import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <div className="w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-stack-fill text-background-50 text-sm"></i>
              </div>
              <span className="font-heading font-bold text-base text-foreground-900 whitespace-nowrap">
                Sugargoo <span className="text-primary-500">Spreadsheet</span> Hub
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
              The ultimate independent Sugargoo Spreadsheet resource. Discover product finds, reviews, shipping guides, coupons and expert shopping tips all in one place.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-800 mb-4">
              <a href="#categories" className="hover:text-primary-500 transition-colors cursor-pointer">Quick Categories</a>
            </h4>
            <ul className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-800 mb-4">
              <Link to="/article/sugargoo-spreadsheet-complete-guide" className="hover:text-primary-500 transition-colors cursor-pointer">Resources</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/article/sugargoo-spreadsheet-complete-guide" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Complete Guide to Sugargoo Spreadsheet
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Visit Main Website
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Frequently Asked Questions
                </a>
              </li>
              <li>
                <a href="#features" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Features &amp; Benefits
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet Hub. An independent resource. Not affiliated with Sugargoo.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              Main Website
            </a>
            <span className="text-foreground-300">·</span>
            <Link to="/article/sugargoo-spreadsheet-complete-guide" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              Complete Guide
            </Link>
            <span className="text-foreground-300">·</span>
            <a href="#faq" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              FAQ
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}